export const INITIAL_FILTERS_STATE = {
  sort_by: 'month',
  order: 'desc',
};
